import { render, staticRenderFns } from "./GroupsAdd.vue?vue&type=template&id=6f9ea3a5"
import script from "./GroupsAdd.vue?vue&type=script&lang=js"
export * from "./GroupsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports